import { getAdapter } from './registry'
import type { PlatformAdapter, AdapterSession } from './types'

interface AuthSessions {
    session?: unknown | null
    mastodonSession?: unknown | null
    pixelfedSession?: unknown | null
}

export interface AdapterWithSession {
    adapter: PlatformAdapter
    session: AdapterSession
}

/**
 * Returns all adapters that have an active session, in a consistent order:
 * bluesky → mastodon → pixelfed.
 *
 * Used by hooks that support protocol: 'all' to fire parallel requests
 * across every authenticated platform.
 */
export function getAllAdaptersWithSessions(auth: AuthSessions): AdapterWithSession[] {
    const result: AdapterWithSession[] = []
    if (auth.session) {
        result.push({ adapter: getAdapter('bluesky'), session: auth.session as AdapterSession })
    }
    if (auth.mastodonSession) {
        result.push({
            adapter: getAdapter('mastodon'),
            session: auth.mastodonSession as AdapterSession,
        })
    }
    if (auth.pixelfedSession) {
        result.push({
            adapter: getAdapter('pixelfed'),
            session: auth.pixelfedSession as AdapterSession,
        })
    }
    return result
}
